import { Link, useLocation } from 'react-router-dom';
import { House, MagnifyingGlass } from 'shared/icons';

/**
 * Página 404 — catch-all (`path="*"`) do layout autenticado no App.js.
 * Sem PermissionGuard de propósito: qualquer usuário logado pode cair aqui
 * ao digitar uma URL errada, e a saída é sempre voltar ao início.
 */
const NotFound = () => {
    const location = useLocation();

    return (
        <div className="flex min-h-[60vh] items-center justify-center">
            <div className="w-full max-w-md rounded-xl border border-mono-200 bg-white p-8 text-center shadow-mono dark:border-mono-800 dark:bg-mono-950 dark:shadow-lg-mono">
                <div className="mx-auto mb-4 inline-flex rounded-full bg-mono-100 p-4 dark:bg-mono-900">
                    <MagnifyingGlass size={40} className="text-mono-700 dark:text-mono-300" />
                </div>

                <p className="text-5xl font-bold tracking-tight text-black dark:text-white">404</p>
                <h1 className="mt-2 text-xl font-semibold text-black dark:text-white">Página não encontrada</h1>
                <p className="mt-2 text-mono-600 dark:text-mono-400">
                    O endereço{' '}
                    <code className="rounded bg-mono-100 px-1.5 py-0.5 text-sm text-mono-800 dark:bg-mono-900 dark:text-mono-200">
                        {location.pathname}
                    </code>{' '}
                    não existe ou foi movido.
                </p>

                <Link
                    to="/"
                    className="mt-6 inline-flex min-w-[200px] items-center justify-center gap-2 rounded-lg bg-black px-4 py-2 text-base font-medium text-white transition-all duration-200 hover:bg-mono-800 focus:outline-none focus:ring-2 focus:ring-mono-500 focus:ring-offset-2 dark:bg-white dark:text-black dark:hover:bg-mono-100"
                >
                    <House size={20} />
                    Voltar ao início
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
